import React              from 'react';
import { useTranslation } from 'react-i18next';

import RenderButton from './base/RenderButton';

import { useSidebar }   from '../../providers/sidebar';
import sidebarConstants from '../../providers/sidebar/sidebar.constants';

const ContactUs = (props) => {
  const { t }           = useTranslation();
  const { showSidebar } = useSidebar();

  const { label } = props;

  return (
    <RenderButton
      action={() => showSidebar(sidebarConstants.CALL_ME_SIDEBAR)}
      label={label || t('client_contactUs')}
    />
  );
};

export default ContactUs;